import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-794eca60")

_pushScopeId("data-v-794eca60")
const _hoisted_1 = { class: "mask" }
const _hoisted_2 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "scroll-item",
    ref: "self$",
    style: { backgroundImage: `url(${_ctx.url})`, opacity: _ctx.opacity }
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ])
  ], 4))
})